import * as React from 'react';
import { InputControlContext } from 'ui/common/input-control-context';
import { ValidationProps } from 'ui/common/validation';
import styles from './link-field.scss';

interface LinkFieldProps {
  componentId: string;
  label: string;
  text: string;
  linkUrl: string;
  children?: React.ReactNode;
  validation: ValidationProps;
}

export const LinkField = ({ componentId, label, text, linkUrl, children, validation }: LinkFieldProps) =>
  <InputControlContext
    componentId={componentId}
    className={styles.linkField}
    label={{ text: label }}
    validation={validation}>
    <div className="input-wrapper">
      <div className="input-group">
        <div className={`form-control ${styles.wrapper}`}>
          {linkUrl
            ? <a href={linkUrl} target="_blank" rel="noopener noreferrer">{text}</a>
            : <textarea className={styles.textarea} disabled={true}>{text}</textarea>}
        </div>
        {children ?? null}
      </div>
    </div>
  </InputControlContext>;
